module.exports = __webpack_public_path__ + "ios.png";